var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var _require = require('buffer'),
    Buffer = _require.Buffer;

var _require2 = require('event-iterator'),
    EventIterator = _require2.EventIterator; // copied from github.com/feross/buffer
// Some ArrayBuffers are not passing the instanceof check, so we need to do a bit more work :(


function isArrayBuffer(obj) {
  return obj instanceof ArrayBuffer || obj != null && obj.constructor != null && obj.constructor.name === 'ArrayBuffer' && typeof obj.byteLength === 'number';
}

module.exports = function (socket) {
  var removeListener = socket.removeEventListener || socket.removeListener;

  var source = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var messages, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            messages = new EventIterator(function (_ref2) {
              var push = _ref2.push,
                  stop = _ref2.stop,
                  fail = _ref2.fail;
              socket.addEventListener('message', push);
              socket.addEventListener('error', fail);
              socket.addEventListener('close', stop);
              return function () {
                removeListener.call(socket, 'message', push);
                removeListener.call(socket, 'error', fail);
                removeListener.call(socket, 'close', stop);
              };
            }, {
              highWaterMark: Infinity
            });
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 3;
            _iterator = _asyncIterator(messages);

          case 5:
            _context.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 14;
              break;
            }

            data = _step.value.data;
            _context.next = 11;
            return isArrayBuffer(data) ? Buffer.from(data) : data;

          case 11:
            _iteratorAbruptCompletion = false;
            _context.next = 5;
            break;

          case 14:
            _context.next = 20;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 20:
            _context.prev = 20;
            _context.prev = 21;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 25;
              break;
            }

            _context.next = 25;
            return _awaitAsyncGenerator(_iterator.return());

          case 25:
            _context.prev = 25;

            if (!_didIteratorError) {
              _context.next = 28;
              break;
            }

            throw _iteratorError;

          case 28:
            return _context.finish(25);

          case 29:
            return _context.finish(20);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 16, 20, 30], [21,, 25, 29]]);
  }))();

  var connected = socket.readyState === 1;
  var connError;
  socket.addEventListener('open', function () {
    connected = true;
    connError = null;
  });
  socket.addEventListener('close', function () {
    connected = false;
    connError = null;
  });
  socket.addEventListener('error', function (err) {
    if (!connected) connError = err;
  });

  source.connected = function () {
    return new Promise(function (resolve, reject) {
      if (connected) return resolve();
      if (connError) return reject(connError);

      var cleanUp = function cleanUp(cont) {
        removeListener.call(socket, 'open', onOpen);
        removeListener.call(socket, 'error', onError);
        cont();
      };

      var onOpen = function onOpen() {
        return cleanUp(resolve);
      };

      var onError = function onError(err) {
        return cleanUp(function () {
          return reject(err);
        });
      };

      socket.addEventListener('open', onOpen);
      socket.addEventListener('error', onError);
    });
  };

  return source;
};